import EventPhaseEventTime from "app/components/EventPhaseEventTime/EventPhaseEventTime";
import TimeSectionTimePhase from "app/components/TimeSectionLivePhase/TimeSectionTimePhase";
import { ScreenType, SportsNameType } from "app/utils/const";
import { MomentTime } from "../../../../components/Moment/Moment";
import { EventHelper } from "../../../../helpers/eventHelper";
import BottomSection from "./components/BottomSection/BottomSection";
import TopSection from "./components/TopSection/TopSection";
import { DisplayStateScores } from "./helpers/DisplayStateScores/DisplayStateScores";
export const AsianEventCellTime = (
  props: Record<string, any>
): React.JSX.Element => {
  // TODO  need to cater for other event states when have more data
  const { eventData } = props;
  const eventIncidents = eventData["eventIncidents"];
  const isEventLive = EventHelper.isEventLive(eventData);
  const isEventPhaseLive = EventHelper.isEventPhaseOfTypeLive(eventData);
  // BET-1841 check if markets contain period of extra time
  const isEventInExtraTime = EventHelper.isEventInExtraTime(eventData);
  const isBeforeExtra = EventHelper.isBeforeExtraTime(eventData);
  //
  const displayIsEventInExtraTime =
    isEventInExtraTime === true ? "extraTime" : "fullTime";
  const scoreFullTime =
    eventData.sportType !== SportsNameType.BOXING &&
    eventIncidents &&
    DisplayStateScores.displayStateScores(
      eventData,
      eventIncidents,
      displayIsEventInExtraTime
    );

  if (isEventLive && isEventPhaseLive) {
    return (
      <div className="asian-event__time-section">
        <TimeSectionTimePhase />
      </div>
    );
  }

  const eventTime =
    eventIncidents && isEventLive ? (
      <div className="asian-popular-event-cell__event-time">
        <EventPhaseEventTime
          eventData={eventData}
          eventIncidents={eventIncidents}
          isBeforeExtra={isBeforeExtra}
          isEventInExtraTime={null}
          screenType={ScreenType.ASIAN}
        />
      </div>
    ) : (
      <MomentTime value={eventData["startTime"]} countDown />
    );

  return (
    <div className="asian-event__time-section">
      <TopSection
        eventData={eventData}
        scoreFullTime={scoreFullTime}
        isEventLive={isEventLive}
      />
      {eventData.sportType !== SportsNameType.GOLF && (
        <BottomSection eventData={eventData} eventTime={eventTime} />
      )}
      {!isEventLive && eventData.sportType === SportsNameType.GOLF && (
        <BottomSection eventData={eventData} eventTime={eventTime} />
      )}
      {isEventLive && eventData.sportType === SportsNameType.GOLF && (
        <TimeSectionTimePhase />
      )}
    </div>
  );
};
export default AsianEventCellTime;
